export default __webpack_public_path__ + "static/media/features-img.5b280fa6.svg";